import storejs from 'store';
import expirePlugin from 'store/plugins/expire';
import appConfig from '../../app-config';

storejs.addPlugin(expirePlugin);

const CacheService = {

    saveCache(key, value, life_time, life_time_type) { // life_time -> mins

        if (appConfig.VUE_APP_ENABLE_CACHE) {
            var maxLife = undefined;

            if (life_time_type == 'day') {
                maxLife = new Date().addDays(life_time).setHours(0, 0, 0, 0);
            }
            else if (life_time_type == 'week') {
                maxLife = new Date().addDays((life_time * 7)).setHours(0, 0, 0, 0);
            }
            else {
                maxLife = new Date().getTime() + (1 * 60 * 1000 * life_time);
            }


            storejs.set(`${key}_${appConfig.VUE_APP_COOKIE_NAME}`, value, maxLife);
        }
        else return;
    },

    getCache(key) {
        var cachedData = storejs.get(`${key}_${appConfig.VUE_APP_COOKIE_NAME}`);

        if (cachedData) {
            return cachedData;
        } else return false;
    },
}


export { CacheService };